import moment from 'moment-timezone';

/**
 * Returns a moment object on the correct timezone (either event defined or client defined)
 * @param {object} event        Event object (from state.events[eventId].event)
 * @param {string} timestamp    Timestamp to instanciate as a moment
 * @param {format} string       (optional) Timestamp format
 * @returns moment
 */

export function eventMomentFactory(event, timestamp = moment().toISOString(), format) {
    if (event?.show_in_user_timezone) {
        return moment(timestamp, format).local();
    }
    return moment.tz(timestamp, format, event?.event_timezone);
}
